// 桥通率 & 桥耗时 bid
export enum Cid {
  OneclickpayModal = 'c_pay_dn1isv21',
}
export enum BridgeBids {
  OpenOneClickPayStart = 'b_pay_open_one_click_pay_start_sc',
  OpenOneClickPaySucc = 'b_pay_open_one_click_pay_succ_sc',
  OpenOneClickPayFail = 'b_pay_open_one_click_pay_fail_sc',
  OpenOneClickPayTimeout = 'b_pay_oneclick_pay_timeout_to_downgrade_sc',
}

export enum BridgeMetricKeys {
  OpenOneClickPayStart = 'hybrid_open_one_click_pay',
  OpenOneClickPaySucc = 'hybrid_open_one_click_pay_succ',
  OpenOneClickPayFail = 'hybrid_open_one_click_pay_fail',
}

export enum AjaxBids {
  // actioninfo 接口
  ActioninfoStart = 'b_pay_cashier_actioninfo_start_sc',
  ActioninfoSucc = 'b_pay_cashier_actioninfo_succ_sc',
  ActioninfoFail = 'b_pay_cashier_actioninfo_fail_sc',
  OneclickpayOpenStart = 'b_pay_oneclickpay_open_start_sc',
  OneclickpayOpenSucc = 'b_pay_oneclickpay_open_succ_sc',
  OneclickpayOpenFail = 'b_pay_oneclickpay_open_fail_sc',
  AdjustQuotaStart = 'b_pay_oneclickpay_adjust_quota_start_sc',
  AdjustQuotaSucc = 'b_pay_oneclickpay_adjust_quota_succ_sc',
  AdjustQuotaFail = 'b_pay_oneclickpay_adjust_quota_fail_sc',
  DeductordersaveStart = 'b_pay_oneclickpay_deductordersave_start_sc',
  DeductordersaveSucc = 'b_pay_oneclickpay_deductordersave_succ_sc',
  DeductordersaveFail = 'b_pay_oneclickpay_deductordersave_fail_sc',
}

export enum AjaxRaptorBids {
  // actioninfo 接口
  ActioninfoStart = 'cashier_actioninfo_start',
  ActioninfoSucc = 'cashier_actioninfo_succ',
  ActioninfoFail = 'cashier_actioninfo_fail',

  OneclickpayOpenStart = 'b_pay_oneclickpay_open_start',
  OneclickpayOpenSucc = 'b_pay_oneclickpay_open_succ',
  OneclickpayOpenFail = 'b_pay_oneclickpay_open_fail',
  AdjustQuotaStart = 'b_pay_oneclickpay_adjust_quota_start',
  AdjustQuotaSucc = 'b_pay_oneclickpay_adjust_quota_succ',
  AdjustQuotaFail = 'b_pay_oneclickpay_adjust_quota_fail',
  DeductordersaveStart = 'b_pay_oneclickpay_deductordersave_start',
  DeductordersaveSucc = 'b_pay_oneclickpay_deductordersave_succ',
  DeductordersaveFail = 'b_pay_oneclickpay_deductordersave_fail',
}

export enum OfflineBids {
  OfflineStatus = 'b_pay_hybrid_one_click_pay_offline_status_sc',
}

export enum OfflineMetricKeys {
  OfflineStatus = 'hybrid_one_click_pay_offline_status',
}

export enum OneClickPayModalProcessBids {
  OpenOneClickPayModalShow = 'b_pay_oneclick_pay_open_confirm_show_sc',
  OneClickPayModalShow = 'b_pay_oneclick_pay_deduct_show_sc',
  OneClickPayAdjustLimit = 'b_pay_oneclick_pay_adjust_quote_show_sc',
}

export enum OneClickPayModalProcessMetricKeys {
  OpenOneClickPayModalShow = 'oneclick_pay_open_confirm_show',
  OneClickPayModalShow = 'oneclick_pay_deduct_show',
  OneClickPayAdjustLimit = 'oneclick_pay_adjust_quote_show',
}

export enum DowngradeMertricKeys {
  DowngradeToStandardCashier = 'oneclick_pay_downgrade_to_standard_cashier',
}

export enum DowngradeBids {
  DowngradeToStandardCashier = 'b_pay_oneclick_pay_downgrade_to_standard_cashier_sc',
}

export enum InsuranceClickMetricKeys {
  InsuranceClick = 'oneclick_pay_insurance_click',
  NoInsuranceUrl = 'oneclick_pay_no_insurance_url',
}
